export const isTourActive = (state) => state.onboarding.isTourActive;
export const shouldStartOnboarding = (state) =>
  state.onboarding.shouldStartOnboarding;
export const getTourQueue = (state) => state.onboarding.tourQueue;



// WEBPACK FOOTER //
// ./src/actions/onboarding/onboardingSelectors.js